<template>
  <div>
    <div :class="[isH5 ? 'feedback-container-h5' : '', 'feedback-container']">
      <div 
        class="feedback-like"
        @mouseenter="isLikeIconHover = true"
        @mouseleave="isLikeIconHover = false"
        @click="onLikeIconClick"
      >
        <Icon :file="likeIcon" width="16px" height="16px"/>
        <div 
          class="tooltip" 
          v-if="isPC"
        >
          {{ TUITranslateService.t("AIDesk.满意") }}  
          <div class="tooltip-arrow"></div>
        </div>
      </div>
      <span class="divider"></span>
      <div 
        class="feedback-dislike"
        @mouseenter="isDislikeIconHover = true"
        @mouseleave="isDislikeIconHover = false"
        @click="onDislikeIconClick"
      >
        <Icon :file="dislikeIcon" width="16px" height="16px"/>
        <div 
          class="tooltip" 
          v-if="isPC"
        >
          {{ TUITranslateService.t("AIDesk.不满意") }}  
        <div class="tooltip-arrow"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import vue from '../../../../adapter-vue';
import Icon from '../../../common/Icon.vue';
import { IMessageModel, TUITranslateService, TUIChatEngine } from '../../../../@aidesk/uikit-engine';
import FeedbackLikeBefore from '../../../../assets/feedback_like_before.svg';
import FeedbackLikeAfter from '../../../../assets/feedback_like_after.svg';
import FeedbackLikeHover from '../../../../assets/feedback_like_hover.svg';
import FeedbackDislikeBefore from '../../../../assets/feedback_dislike_before.svg';
import FeedbackDislikeAfter from '../../../../assets/feedback_dislike_after.svg';
import FeedbackDislikeHover from '../../../../assets/feedback_dislike_hover.svg';
import { isPC, isH5 } from '../../../../utils/env';
import { throttle } from '../../../../utils/utils';
import { Toast, TOAST_TYPE } from '../../../common/Toast/index-web';
import { FeedbackType } from '../../../../constant';
const { ref,computed } = vue;

export default {
  components:{
    Icon
  },
  props: {
    message: {
      type: Object,
      required: true,
      default: function() {
        return {} as IMessageModel;
      }
    }
  },
  setup(props, { emit }){
    const isLikeIconHover = ref(false);
    const isLikeIconClick = ref(false);
    const isLikeIconCancelled = ref(false);
    const isDislikeIconHover = ref(false);
    const isDislikeIconClick = ref(false);
    const isDislikeIconCancelled = ref(false);
    const feedbackChangeAllowSeconds = 180; // 评价后允许修改的时间，单位秒
    const isLikeSelectedDone = computed(() => {
      try {
        const jsonObj = JSON.parse(props.message.cloudCustomData);
        return jsonObj.feedBackType === FeedbackType.LIKE;
      } catch (error) {
        return false;
      }
    });
    const isDislikeSelectedDone = computed(() => {
      try {
        const jsonObj = JSON.parse(props.message.cloudCustomData);
        return jsonObj.feedBackType === FeedbackType.DISLIKE;
      } catch (error) {
        return false;
      }
    });
    const isFeedBackAllowChange = computed(() => {
      try {
        const jsonObj = JSON.parse(props.message.cloudCustomData);
        return typeof jsonObj.isFeedBackAllowChange === 'boolean' ? jsonObj.isFeedBackAllowChange : undefined;
      } catch (error) {
        return undefined;
      }
    });
    const firstFeedbackTime = computed(() => {
      try {
        const jsonObj = JSON.parse(props.message.cloudCustomData);
        return jsonObj.firstFeedBackTime || -1;
      } catch (error) {
        return 0;
      }
    });

    const likeIcon = computed(() => {
      if (isLikeSelectedDone.value) {
        if (isLikeIconCancelled.value) {
          return FeedbackLikeBefore;
        }
        return FeedbackLikeAfter;
      } else if (isLikeIconClick.value) {
        return FeedbackLikeAfter;
      } else if (isLikeIconHover.value) {
        return FeedbackLikeHover;
      } else {
        return FeedbackLikeBefore;
      }
    });
    const dislikeIcon = computed(() => {
      if (isDislikeSelectedDone.value) {
        if (isDislikeIconCancelled.value) {
          return FeedbackDislikeBefore;
        }
        return FeedbackDislikeAfter;
      } else if (isDislikeIconClick.value) {
        return FeedbackDislikeAfter;
      } else if (isDislikeIconHover.value) {
        return FeedbackDislikeHover;
      } else {
        return FeedbackDislikeBefore;
      }
    });
    const isC2C = props.message.conversationType === TUIChatEngine.TYPES.CONV_C2C;
    const messageInfo = {
      msgSeq: props.message.sequence,
      cloudCustomData: props.message.cloudCustomData,
      // 网站渠道或测试窗
      groupId: props.message.conversationType === TUIChatEngine.TYPES.CONV_GROUP ? props.message.to : null,
      // uikit
      // fromAccount: who sends the feedback, props.message.to : robot message recipient
      fromAccount: isC2C ? props.message.to : null,
      // toAccount: who receipts the feedback (customer service account)
      toAccount: isC2C ? props.message.from : null,
      msgRandom: isC2C ? props.message.random : null,
      msgTime: isC2C ? props.message.time : null,
    };
     const feedbackChangeErrorToast = () => {
      Toast({
        message: TUITranslateService.t('AIDesk.评价提交超过3分钟，无法更改。感谢您的反馈！'),
        type: TOAST_TYPE.ERROR,
        duration: 3000,
      });
    }
    const onLikeIconClick = throttle(() => {
      let type = FeedbackType.LIKE;
      const alreadyLike = isLikeSelectedDone.value || isLikeIconClick.value;
      const alreadyDislike = isDislikeSelectedDone.value || isDislikeIconClick.value;
      const feedbackTimeFromNow =  Math.floor(Date.now() / 1000) - firstFeedbackTime.value;
      if (isFeedBackAllowChange.value === undefined && (alreadyLike || alreadyDislike)) {
        return;
      }
      if (isFeedBackAllowChange.value === false || (firstFeedbackTime.value > 0 && feedbackTimeFromNow > feedbackChangeAllowSeconds)) {
        feedbackChangeErrorToast();
        return;
      }
      if (alreadyLike) {
        isLikeIconClick.value = false;
        isLikeIconCancelled.value = true;
        type = FeedbackType.CANCEL_LIKE;
      } else if (alreadyDislike) {
        isDislikeIconClick.value = false;
        isLikeIconClick.value = true;
        isLikeIconCancelled.value = false;
        isDislikeIconCancelled.value = true;
      } else {
        isLikeIconClick.value = true;
        isDislikeIconCancelled.value = false;
        isLikeIconCancelled.value = false;
      }
      emit('like', type, messageInfo);
    }, 300);

    const onDislikeIconClick = throttle(() => {
      let type = FeedbackType.DISLIKE;
      const alreadyLike = isLikeSelectedDone.value || isLikeIconClick.value;
      const alreadyDislike = isDislikeSelectedDone.value || isDislikeIconClick.value;
      const feedbackTimeFromNow =  Math.floor(Date.now() / 1000) - firstFeedbackTime.value;
      if (isFeedBackAllowChange.value === undefined && (alreadyLike || alreadyDislike)) {
        return;
      }
      if (isFeedBackAllowChange.value === false || (firstFeedbackTime.value > 0 && feedbackTimeFromNow > feedbackChangeAllowSeconds)) {
        feedbackChangeErrorToast();
        return;
      }
      if (alreadyDislike) {
        isDislikeIconClick.value = false;
        isDislikeIconCancelled.value = true;
        type = FeedbackType.CANCEL_DISLIKE;
      } else if (alreadyLike) {
        isLikeIconClick.value = false;
        isDislikeIconClick.value = true;
        isDislikeIconCancelled.value = false;
        isLikeIconCancelled.value = true;
      } else {
        isDislikeIconClick.value = true;
        isDislikeIconCancelled.value = false;
        isLikeIconCancelled.value = false;
      }
      emit('dislike', type, messageInfo);
    }, 300);

    return {
      likeIcon,
      isLikeIconHover,
      onLikeIconClick,
      isDislikeIconHover,
      dislikeIcon,
      onDislikeIconClick,
      TUITranslateService,
      isPC,
      isH5,
    };
  }
}
</script>
<style lang="scss">
.feedback-container {
  display: flex;
  flex-direction: row !important;
  padding: 4px 10px;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid var(---G61, #DBE1EB);
  background-color: #fff;
  .feedback-like, .feedback-dislike {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover .tooltip {
      display: block;
    }
  }
  .divider {
    width: 1px;
    height: 14px;
    background-color: rgba(0,0,0,0.05);
  }
}
.feedback-container-h5 {
  background-color: rgba(255,255,255,0.75);
}
.tooltip {
  position: absolute;
  z-index: 100;
  font-size: 14px;
  bottom: calc(100% + 13px);
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  color: #000;
  padding: 8px 16px;
  border-radius: 6px;
  box-shadow: var(--shadow-md-offsetx-1, 0px) var(--shadow-md-offsety-1, 8px) var(--shadow-md-blur-1, 12px) var(--shadow-md-spread-1, -8px) var(--shadow-md-color-1, rgba(0, 0, 0, 0.05)), var(--shadow-md-offsetx-2, 0px) var(--shadow-md-offsety-2, 8px) var(--shadow-md-blur-2, 24px) var(--shadow-md-spread-2, -4px) var(--shadow-md-color-2, rgba(0, 0, 0, 0.10));
  text-align: center;
  display: none;
  white-space: nowrap;
  
  &-arrow {
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #fff; 
  }
}
</style>